export const FeatureFlagContextBaseState = {
  allFlags: [],
  contentFeed: false,
  experimentalFeatures: false,
  hasLoaded: false,
  knockFeed: false,
  vendorDashboard: false,
}
